import posthog from 'posthog-js';

export const posthogInit = () => {
  if (
    typeof window !== 'undefined' &&
    process.env.NEXT_PUBLIC_POSTHOG_KEY &&
    !posthog.__loaded
  ) {
    posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
      api_host:
        process.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://eu.i.posthog.com',
      ui_host: 'https://eu.posthog.com',
      autocapture: {
        dom_event_allowlist: ['click', 'submit'],
        element_allowlist: [],
        css_selector_allowlist: ['[data-ph-capture]'],
      },
      capture_pageview: false, // Manual capture for SPA navigation
      capture_pageleave: true,
      persistence: 'localStorage+cookie',
      cross_subdomain_cookie: true,
      opt_out_capturing_by_default: true,
      session_recording: {
        maskAllInputs: true,
        maskTextSelector: '[data-ph-mask]',
      },
    });
  }

  return posthog;
};

export default posthog;
